package com.example.mystybag.sharedmodels.project.responseModels

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class EnrollUsrResponseModel(
    var userId          : Long    = 0L,
    var code            : String  = ""
): BaseResponseModel()
